import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import { IAllocationReportDetails } from '@irb/irb-dashboard/irb-dashboard.model';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({
  standalone: false,
  selector: 'irb-com-allocation',
  templateUrl: './com-allocation.component.html',
  styleUrls: ['./com-allocation.component.scss']
})
export class ComAllocationComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private _data: IAllocationReportDetails;
  chartData: any;
  colors: Array<string> = [
    "#FF8800",
    "#3C842B",
    "#CECECE"
  ];

  options: any = {
    responsive: true,
    maintainAspectRatio: false,
    circumference: 180,
    rotation: 270,
    cutoutPercentage: 50,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    }
  };

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {
    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {   
      if(d) {
        this.dbs.getAllocationReportDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
          this.data = d as IAllocationReportDetails;
          this.update();
          this.cdr.detectChanges();
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  update() {
    const a = (this.data.outOfToleranceCount / this.data.totalPortfolios) * 100;
    const b = (this.data.inToleranceCount / this.data.totalPortfolios) * 100;
    const c = (this.data.others / this.data.totalPortfolios) * 100;

    this.chartData = {
      datasets: [
          {
              data: (this.data.totalPortfolios > 0) ? [a,b,c] : [100],
              backgroundColor: (this.data.totalPortfolios > 0) ? this.colors : ["#CECECE"], 
              hoverBackgroundColor: (this.data.totalPortfolios > 0) ? this.colors : ["#CECECE"],
              borderWidth: 2,
              hoverBorderColor: ["#FFFFFF"]
          }
      ]
    };
  }

  showAllocationReport() {
    this.ats.trackPassiveEvent("lc_alloreport");
    this.router.navigate(['/reports/allocation-report']);
  }

  showAllocationReportWithOutOfTolerance() {
    this.ats.trackPassiveEvent("lc_outoftolerance");
    this.as.setToSession("ALLOCATION_REPORT_STATUS_FILTER_DEFAULT","Out of Tolerance "+"("+this.data.outOfToleranceCount+")");
    this.router.navigate(['/reports/allocation-report']);
  }

  showAllocationReportWithInTolerance() {
    this.ats.trackPassiveEvent("lc_intolerance");
    this.as.setToSession("ALLOCATION_REPORT_STATUS_FILTER_DEFAULT","In Tolerance "+"("+this.data.inToleranceCount+")");
    this.router.navigate(['/reports/allocation-report']);
  }

  get data() {
    return this._data;
  }

  set data(d: IAllocationReportDetails) {
    this._data = d;
  }
}
